import styled from '@emotion/styled';
import { FunctionComponent } from 'react';

const StyledButton = styled.button`
  display: none;
`;

export const HiddenSubmitButton: FunctionComponent = () => <StyledButton type="submit">Hidden</StyledButton>;
